import clsx from 'clsx';
import React from 'react';

import { TESTIMONIAL_DATA } from './constant';

const Testimonials = () => {
  return (
    <div className="px-12">
      <div className="m-auto max-w-container-lg">
        <aside>
          <div className="md:gap-y-14 grid grid-cols-1 justify-items-center gap-32 sm:grid-cols-2 md:gap-x-8 lg:gap-x-32 lg:gap-y-16 xl:gap-x-72">
            {TESTIMONIAL_DATA.map((testimonial, index) => (
              <article
                className={clsx(
                  'flex w-full flex-col border-0 border-b-[3px] border-solid border-primary-magenta pb-10 text-left sm:w-[min(100%,440px)]',
                  {
                    'justify-self-end': index === 0,
                    'justify-self-start': index === 1,
                  }
                )}
                key={testimonial.name}
              >
                <div className="pull-quote !mb-0 !mt-0 !min-h-[46px] flex-row !pt-0 text-headline-xs before:!-ml-12 before:!max-h-[46px] before:!min-h-[46px] before:!text-[160px] before:leading-[0.8]" />
                <div className="mt-24 max-w-full font-suisse-neue text-body-md md:mt-16">
                  {testimonial.quote}
                </div>
                <div className="mt-24 font-suisse-screen">
                  <span className="text-byline-lg">{testimonial.name}</span>
                  <span className="text-byline-md text-grayscale-charcoal">
                    {' '}
                    | {testimonial.title}
                  </span>
                </div>
              </article>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Testimonials;
